import * as React from 'react'

import styles from './video.module.scss'

const Video = () => (
  <div className={styles.container}>
    <div className={styles.video}>
      <iframe
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        className={styles.videoPlayer}
        src={`https://www.youtube-nocookie.com/embed/x6L5YouLgCE?rel=0`}
        title="bokforing"
      />
    </div>
  </div>
)

export default Video
